import "./Album.module.css";
import Header from "@/reusable_sections/Header";
import ConstructionGallery from "./sections/ConstructionGallery";
import Portfolio from "./sections/Portfolio";
import PortfolioCopy from "@/pages/Album/sections/PortfolioCopy";
import PortfolioCopyCopy from "@/pages/Album/sections/PortfolioCopyCopy";
import Footer from "@/reusable_sections/Footer";
export default function AlbumPage() {
  return <div>
      <Header />
      
      <ConstructionGallery />
      <Portfolio />
      <PortfolioCopy />
      <PortfolioCopyCopy />
      <Footer />
    </div>;
}